import domready from "domready";
domready(function () {
  var singleSelects = document.querySelectorAll(".input--singleselect select");
  if (singleSelects !== null) {
    Array.prototype.forEach.call(singleSelects, function (el) {
      el.addEventListener("click", function () {
        el.classList.add("selected");
      });
    });
  }
});
